import axios from 'axios';
import { ADMIN_API_URL } from '../env';

// ADMIN_API_URL is injected at runtime via /env-config.js; falls back to
// import.meta.env.VITE_ADMIN_API_URL for local dev without Docker.
const BASE_URL = ADMIN_API_URL;

const client = axios.create({
  baseURL: `${BASE_URL}/admin`,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('admin_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ---- Analytics ----
export const getAnalyticsSummary = () => client.get('/analytics/summary');
export const getGeoAnalytics = () => client.get('/analytics/geo');
export const getUserAnalytics = (range = '30d') => client.get(`/analytics/users?range=${range}`);
export const getActivityAnalytics = (range = '30d') => client.get(`/analytics/activity?range=${range}`);
export const getLearningAnalytics = () => client.get('/analytics/learning');
export const getRevenueAnalytics = () => client.get('/analytics/revenue');

// ---- Content ----
export const getContentStats = () => client.get('/content/stats');

// ---- LLM Config ----
export const getLLMChains = () => client.get('/llm/chains');
export const getLLMProviders = () => client.get('/llm/providers');
export const getVoiceConfig = () => client.get('/llm/voice');
export const getLLMUsage = (days = 7) => client.get(`/llm/usage?days=${days}`);
export const getSystemPrompts = () => client.get('/llm/prompts');

// ---- Custom Subject Requests ----
export const getCustomSubjectRequests = (status = 'pending') =>
  client.get(`/custom-subjects/?status=${status}`);
export const approveCustomSubject = (id: number) =>
  client.post(`/custom-subjects/${id}/approve`);
export const rejectCustomSubject = (id: number) =>
  client.post(`/custom-subjects/${id}/reject`);

export default client;
